<template>
  <header class="app-header">
    <a class="brand-lockup" href="/" aria-label="Stratitude Share home" @click="go($event, '/')">
      <img src="/images/branding/stratitude-logo-2026-black.png" alt="Stratitude" class="brand-lockup__wordmark">
      <span class="brand-lockup__divider" aria-hidden="true"></span>
      <span class="brand-lockup__product">Share</span>
    </a>

    <nav class="app-nav" aria-label="File sharing">
      <a
        href="/"
        class="app-nav__link"
        :class="{ 'app-nav__link--active': activeView === 'upload' }"
        :aria-current="activeView === 'upload' ? 'page' : null"
        @click="go($event, '/')"
      >
        <svg class="ui-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M5 14v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4"/>
        </svg>
        <span>Upload</span>
      </a>

      <a
        href="/our-shares"
        class="app-nav__link"
        :class="{ 'app-nav__link--active': activeView === 'activity' }"
        :aria-current="activeView === 'activity' ? 'page' : null"
        @click="go($event, '/our-shares')"
      >
        <svg class="ui-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M8 12h8m-4-4v8M5 5.5A2.5 2.5 0 0 1 7.5 3h9A2.5 2.5 0 0 1 19 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 18.5z"/>
        </svg>
        <span>Our shares</span>
      </a>
    </nav>

    <div class="account-menu">
      <div class="account-menu__copy">
        <span>Signed in</span>
        <strong>{{ userEmail }}</strong>
      </div>
      <button
        class="btn-ui btn-ui--secondary btn-ui--compact"
        type="button"
        :disabled="logoutLoading"
        @click="$emit('logout')"
      >
        <svg class="ui-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M10 5H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4m5-4 3-3-3-3m3 3H9"/>
        </svg>
        <span>{{ logoutLoading ? 'Signing out…' : 'Sign out' }}</span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',

  props: {
    activeView: {
      type: String,
      required: true
    },
    userEmail: {
      type: String,
      default: ''
    },
    logoutLoading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    go: function (event, path) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return
      }

      event.preventDefault()
      this.$emit('navigate', path)
    }
  }
}
</script>
